<div class="row g-4 mb-3">
  @if ((isEditor || isOwner) && currentProject) {
    <div class="col-sm-auto">
      <div>
        <button type="button" (click)="openCreateAssessmentModal()" class="btn btn-success add-btn me-1" [disabled]="current_client.plan === null">
          <i class="ri-add-line align-bottom me-1"></i> Create new subject file </button>
        </div>
      </div>
    }
    @if (!currentProject) {
      <div class="col-sm-auto">
        <h1>Assessments</h1>
      </div>
    }
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end">
        <div class="search-box ms-2">
          <input type="text" class="form-control search" placeholder="Search by ID..." [(ngModel)]="searchText" (input)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th scope="col" style="width: 50px;">No.</th>
          <th>ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Created By</th>
          <th>Create Date</th>
          <th>Status</th>
          @if (isAllow) {
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center"><app-loading-spinner></app-loading-spinner></td>
          </tr>
        }
        @if (!loading && assessments && assessments.length > 0) {
          @for (assessment of assessments; track assessment) {
            <tr>
              <td>{{ assessment.id }}</td>
              <td>
                <ngb-highlight [result]="assessment.subject_id" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="assessment.subject_details.first_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="assessment.subject_details.last_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>{{ assessment.case_owner_user.person.first_name + ' ' + assessment.case_owner_user.person.last_name }}</td>
              <td>{{ assessment.createdAt | date: 'medium' }}</td>
              <td>
                <span class="badge bg-{{ getStatusColor(assessment.status) }}-subtle text-{{ getStatusColor(assessment.status) }} fs-11">{{ assessment.status | titlecase }}</span>
              </td>
              @if (isAllow) {
                <td>
                  <div class="d-flex gap-2">
                    @if ((isEditor && assessment.status === 'WAITING') || isAnalyst || isOwner) {
                      <div class="edit">
                        <button class="btn btn-sm btn-success edit-item-btn" ngbTooltip="View Subject Assessments" alt="View Subject Assessments" [routerLink]="currentProject ? 'assessment/' + assessment.id : '/projects/' + assessment.project?.id + '/assessment/' + assessment.id">
                          <i class=" ri-eye-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if ((isEditor && assessment.status === 'WAITING') || isOwner) {
                      <div class="remove">
                        <button (click)="openDeleteAssessmentModal(assessment, deleteAssessmentModal)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove Assessment" alt="Remove Assessment">
                          <i class="ri-delete-bin-line align-middle"></i>
                        </button>
                      </div>
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (!loading && assessments && assessments.length === 0) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center">No assessments files found.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!loading && assessments && assessments.length > 0) {
    <div class="row justify-content-md-between align-items-md-center">
      <div class="col col-sm-6">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalAssessments}} entries </div>
      </div>
      <div class="col col-sm-6">
        <div class="text-sm-right float-end listjs-pagination">
          <ngb-pagination [collectionSize]="totalAssessments" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getAssessments()"></ngb-pagination>
        </div>
      </div>
    </div>
  }

  <app-create-assessment #createAssessmentModal (assessmentChanged)="afterAssessmentCreation($event)"></app-create-assessment>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ title }}</h4>
          @if (!success) {
            <p class="text-muted mx-4 mb-0">{{ message }}</p>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteAssessmentModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you sure you want to delete <span class="fw-semibold text-warning">{{ selectedAssessment.subject_details.first_name + ' ' + selectedAssessment.subject_details.last_name }} </span>case?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load"  [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''" (click)="deleteCase()">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>